export { default } from './Cooperation.component';
